<template>
  <PopWrapper
    :title="title"
    @close="$emit('cancel')"
    @confirm="confirm"
    @cancel="$emit('cancel')"
  >
    <SelectRole
      ref="selectRole"
      :show-role="showRole"
      :bind-games="bindGames"
    />
  </PopWrapper>
</template>

<script>
import SelectRole from './main'
import PopWrapper from '~/components/common/PopWrapper'
export default {
  components: {
    PopWrapper,
    SelectRole
  },
  props: {
    showRole: {
      type: Boolean,
      default: true
    },
    bindGames: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      required: true
    }
  },
  methods: {
    confirm() {
      const { curGame, curArea, curRole } = this.$refs.selectRole
      this.$emit('confirm', { curGame, curArea, curRole })
    },
    destroyElement() {
      this.$el.parentNode && this.$el.parentNode.removeChild(this.$el)
      this.$destroy(true)
    }
  }
}
</script>
